import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { CategoryNodeState } from '@core/models/category.state';
import { MockDataService } from '@core/services/mock-data.service';

import { mockResponse } from '../mock-response';
import { CategoryRepository } from './category.repository';
import { seedCategories } from './category.seed';

const COLLECTION = 'categories';

@Injectable()
export class CategoryMockRepository implements CategoryRepository {
  private readonly categories = inject(MockDataService).collection<CategoryNodeState>(COLLECTION, seedCategories);

  tree(): Observable<CategoryNodeState[]> {
    return mockResponse(this.buildTree());
  }

  getBySlug(slug: string): Observable<CategoryNodeState | null> {
    const flat = this.categories.list();
    const node = flat.find(c => c.slug === slug);
    if (!node) return mockResponse(null);
    return mockResponse({ ...node, children: flat.filter(c => c.parentId === node.id).map(c => ({ ...c })) });
  }

  /** Seed rows are flat (children always []); assemble the two-level tree here. */
  private buildTree(): CategoryNodeState[] {
    const flat = this.categories.list();
    return flat
      .filter(c => c.parentId === null)
      .map(root => ({ ...root, children: flat.filter(c => c.parentId === root.id).map(c => ({ ...c })) }));
  }
}
